export default function CurrencyLatest(amount) {
  return numberWithCommas(Math.floor(amount));
}

function numberWithCommas(x) {
  console.log("number with commas value", x);
  const formattedValue = new Intl.NumberFormat().format(x);
  return formattedValue;
}
